










import { Vue, Component } from "../vue-ext";
import { HousingCompany } from "../models";

@Component
export default class EmergencyPlanView extends Vue {
    private emergencyPlanLink: string | null = null;

    private async created() {
        this.root.setTitle(this.$t("menu.emergencyPlan") as string);
        this.root.setIconClass("icon-pelastussuunnitelma");
        const housingCompany = this.root.getCurrentHousingCompany() as HousingCompany;
        this.emergencyPlanLink = await this.root.service.housingCompany.GetEmergencyPlanLink(housingCompany.housingCompanyId);
    }
}
